"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const common_components_1 = require("@zapier/common-components");
const rootStyle = core_1.css `
  background-color: ${design_system_1.Colors.grey000};
  border-radius: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  line-height: 25px;
  padding: 50px 30px;
  text-align: center;
`;
const headerStyle = core_1.css `
  margin-bottom: 6px;
  margin-top: 10px;
`;
const emojiStyle = core_1.css `
  font-size: 40px;
  margin-bottom: 8px;
  margin-right: 10px;
`;
const messageStyle = core_1.css `
  font-size: 16px;
  color: ${design_system_1.Colors.grey700};
`;
const buttonsContainerStyle = core_1.css `
  padding-top: 20px;
`;
const buttonWrapperStyle = core_1.css `
  margin: 5px;
`;
const UnhandledSampleStateMessage = ({ state }) => (core_1.jsx("div", { css: rootStyle },
    core_1.jsx("div", { css: emojiStyle },
        core_1.jsx(common_components_1.Emoji, { label: "Unhandled state error", symbol: "\uD83D\uDED1" })),
    core_1.jsx("div", { css: headerStyle },
        core_1.jsx(design_system_1.Text, { tag: "p", type: "subtitle800" }, "That's unexpected!")),
    core_1.jsx("div", { css: messageStyle },
        "Oops, looks like we got our wires crossed and ended up in an unexpected",
        ' ',
        state,
        " state. Please refresh the page and try again."),
    core_1.jsx("div", { css: buttonsContainerStyle },
        core_1.jsx("span", { css: buttonWrapperStyle },
            core_1.jsx(design_system_1.Button, { color: "blue", hasShadow: true, onClick: () => location.reload(), size: "medium" }, "Reload")))));
exports.default = UnhandledSampleStateMessage;
